<template>
  <div class="form-group">
    <label class="layout-label-option">
      {{ $i18nPresenter.t('Layout') }}
      <span class="title-table-presentation-tooltip result-layout-tooltip">
        <b-button v-tooltip="$i18nPresenter.t('Choose how the result should be displayed')" class="tooltip-btn" />
        <i class="fas fa-question-circle" />
      </span>
    </label>
    <div class="mc-types-box">
      <div
        class="bars-box"
        v-for="(item,index) in layouts"
        :key="item.type"
        @click="selectLayout(item,index)"
        :class="{active: slideActive.layout == item.type}"
      >
        <div class="bars-box-content vertical center-justified layout">
          <i :class="item.icon" />
          <p style="margin: 0;">
            {{ $i18nPresenter.t(item.name) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

// constants
import constants from '@/constant'

// utils
import utils from '@/util'

import Config from '@/config'
import Socket from '@/socket'

const { openEndedLayout, eventCategories } = constants

export default {
  data() {
    return {
      layouts: openEndedLayout,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncPresentationAction']),
    async selectLayout(item) {
      this.updateSlideActiveAction({ layout: item.type })

      utils.uploadSlide(this.slideActive, this.presentation)
      this.setSyncPresentationAction(1)

      try {
        const payload = {
          layout: item.type,
          presentationId: this.presentation.id,
          accessCode: this.presentation.uniqueAccessCode,
          socketId: Socket.getSocketId(),
          presenting: this.$store.getters.isPresenting,
        }
        await this.$http.put(Config.api.updateSlide + this.slideActive.id, payload)

        this.setSyncPresentationAction(2)
        utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Open Ended > Change result layout > Succeeded')
      } catch {
        this.setSyncPresentationAction(3)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variable.scss';
.layout-label-option {
  margin: 0 0 10px;
}
.mc-types-box {
  overflow: hidden;
}

.bars-box {
  float: left;
  width: 119px;
  margin-right: 10px;
  border: 1px solid #d0d0d0;
  color: #d0d0d0;
  text-align: center;
  border-radius: 4px;
  margin-bottom: 10px;

  &:hover {
    border: 1px solid $primary-color;
    cursor: pointer;
  }
  &:nth-child(3n + 3) {
    margin-right: 0;
  }
  .bars-box-content {
    padding: 8px 0 5px 0;
    height: 75px;
  }
}

.active {
  border: 1px solid $primary-color;
  color: $primary-color;
  &:hover {
    border: 1px solid $primary-color;
    cursor: pointer;
  }
}
</style>
